import React from "react";

export const LogoMark = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <path d="M6 27 C14 21 26 21 34 15" stroke="#19C7C1" strokeWidth="2.6" strokeLinecap="round" opacity="0.95" />
    <path d="M6 21 C14 15 26 15 34 9" stroke="#19C7C1" strokeWidth="2.6" strokeLinecap="round" opacity="0.55" />
    <path d="M6 33 C14 27 26 27 34 21" stroke="#19C7C1" strokeWidth="2.6" strokeLinecap="round" opacity="0.3" />
  </svg>
);

export const Logo = ({ dark = false, size = "md" }) => {
  const textColor = dark ? "#061A26" : "#FFFFFF";
  const fontSize = size === "lg" ? "1.5rem" : "1.15rem";
  return (
    <span className="inline-flex items-center gap-2.5 select-none" data-testid="nortis-logo">
      <LogoMark size={size === "lg" ? 36 : 28} />
      <span
        style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 700,
          fontSize,
          letterSpacing: "0.22em",
          color: textColor,
          lineHeight: 1,
        }}
      >
        NORTIS
      </span>
    </span>
  );
};
